import { AdditionalField } from './additional-field.model';

/**
 * Docebo Filter Catalog Model used for courses
 */
export class FilterField {
  constructor(
    public id: number, // Can be a subscription id or course id
    public name: string,
    public additional_fields: AdditionalField[]
  ) {}
}
